import React from 'react';
import JiraIssueIcon from './JiraIssueIcon';
import JiraStatus from './JiraStatus';
import * as Styled from './styled';
import { VerticalDivider } from '../../../../styled';


const Title = ({ item }:any) => {
  const issueStatus = [
    <JiraIssueIcon type={item.issueTypeName} data={item.fields.issuetype} />,
    <JiraStatus status={item.statusName} />,
    item.assigneeName ? <span>Assigned to <span className="font-600">{item.assigneeName}</span></span> : '',
    item.priorityName ? (
      <span>
            {item.fields.priority.iconUrl && <img height="18" width="18" src={item.fields.priority.iconUrl} alt={'priority icon'} />}
        <span className="font-600" style={{ color: item.fields.priority.color || 'inherit', paddingLeft: 5 }}>
              {item.priorityName}
            </span> Priority
          </span>
    ) : '',
  ].filter(s => !!s);
  return (
    <div>
      <Styled.LinkTitle href={item.issueLink} target="jira">
        {item.key} {item.title}
      </Styled.LinkTitle>
      <Styled.JiraIssueContainer>
        {issueStatus.map((s, i) => (
          <React.Fragment key={i}>
            {s}
            {(i < issueStatus.length - 1) && <VerticalDivider />}
          </React.Fragment>
        ))}
      </Styled.JiraIssueContainer>
    </div>
  )
}

export default Title;